import qs from 'qs';

import { SubscribePlan } from '@zep/types';

import { OnetimePeriod, PlanTemplateType, SubscriptionPeriod } from '../types';

/**
 * 주어진 파라미터를 바탕으로 결제 페이지로 이동할 쿼리 문자열을 생성합니다.
 * 이 함수는 쿼리 문자열만 생성하며, 실제로 페이지 이동은 처리하지 않습니다.
 * @param params
 *  - planType: 결제할 요금제 타입
 *  - planTemplateType: 결제할 요금제 템플릿 타입
 *  - spaceHashId: 결제할 공간의 해시 아이디
 *  - maxCcu: 최대 CCU
 *    - 해당 값은 필수가 아닙니다.
 *    - 해당 값이 주어지지 않으면 플랜별 최소값으로 설정됩니다.
 *    - Basic: 20, Pro: 10
 */
export const generatePaymentQuery = (params: Params) => {
  return qs.stringify({
    ...params,
    maxCcu: params.maxCcu ?? params.planType === 'basic' ? 20 : 10,
  });
};

type BaseParams = {
  planType: Omit<SubscribePlan, 'free'>;
  planTemplateType: PlanTemplateType;
  spaceHashId: string;
  maxCcu?: number;
};

type SubscriptionParams = BaseParams & {
  planTemplateType:
    | PlanTemplateType.PRODUCT_SUBSCRIPTION
    | PlanTemplateType.CUSTOM_SUBSCRIPTION;
  subscriptionPeriod: SubscriptionPeriod;
  onetimePeriod?: never;
};

type OnetimeParams = BaseParams & {
  planTemplateType: PlanTemplateType.PRODUCT_ONETIME;
  onetimePeriod: OnetimePeriod;
  subscriptionPeriod?: never;
};

type Params = SubscriptionParams | OnetimeParams;
